export enum ProcessTaskType {
    configureHolter = 'configureHolter',
    createQuestionnaire = 'createQuestionnaire',
    createScreening = 'createScreening',
    dietConsultReport = 'dietConsultReport',
    dietitianReport = 'dietitianReport',
    finishDraftAddToMdo = 'finishDraftAddToMdo',
    finishDraftCloseProcess = 'finishDraftCloseProcess',
    finishDraftConsult = 'finishDraftConsult',
    finishDraftDietitianReport = 'finishDraftDietitianReport',
    finishDraftEchographyConsultRequest = 'finishDraftEchographyConsultRequest',
    finishDraftEvaluation = 'finishDraftEvaluation',
    finishDraftFollowUpConsult = 'finishDraftFollowUpConsult',
    finishDraftGrading = 'finishDraftGrading',
    finishDraftHeadacheReferral = 'finishDraftHeadacheReferral',
    finishDraftHearingLossExamination = 'finishDraftHearingLossExamination',
    finishDraftLifestyleCoachReport = 'finishDraftLifestyleCoachReport',
    finishDraftLumbarRadiculopathyReferral = 'finishDraftLumbarRadiculopathyReferral',
    finishDraftMedConsultExamResults = 'finishDraftMedConsultExamResults',
    finishDraftNote = 'finishDraftNote',
    finishDraftNurseSpecialistReport = 'finishDraftNurseSpecialistReport',
    finishDraftPoliReport = 'finishDraftPoliReport',
    finishDraftPsychologistReport = 'finishDraftPsychologistReport',
    finishDraftReferral = 'finishDraftReferral',
    finishDraftRequest = 'finishDraftRequest',
    finishDraftSecretarialAssistentFollowUp = 'finishDraftSecretarialAssistentFollowUp',
    finishDraftTreatmentChoice = 'finishDraftTreatmentChoice',
    lifestyleCoachReport = 'lifestyleCoachReport',
    medConsultPlanAppointment = 'medConsultPlanAppointment',
    nurseSpecialistFollowUp = 'nurseSpecialistFollowUp',
    nurseSpecialistMedScreeningReport = 'nurseSpecialistMedScreeningReport',
    nurseSpecialistReferral = 'nurseSpecialistReferral',
    nurseSpecialistReport = 'nurseSpecialistReport',
    performAddGeneralPractitioner = 'performAddGeneralPractitioner',
    performAddSkinPrickTestResults = 'performAddSkinPrickTestResults',
    performCaroInactivityReport = 'performCaroInactivityReport',
    performConsultation = 'performConsultation',
    performDietPlanAppointment = 'performDietPlanAppointment',
    performDietScreening = 'performDietScreening',
    performEchographyAdditionalQuestionRequest = 'performEchographyAdditionalQuestionRequest',
    performEchographyAdditionalReply = 'performEchographyAdditionalReply',
    performEchographyConsultResponse = 'performEchographyConsultResponse',
    performEnrollment = 'performEnrollment',
    performGrading = 'performGrading',
    performHeadacheAssessment = 'performHeadacheAssessment',
    performHeadacheExamination = 'performHeadacheExamination',
    performHearingLossAssessment = 'performHearingLossAssessment',
    performHearingLossAudiologistConsult = 'performHearingLossAudiologistConsult',
    performHearingLossAudiologistFollowUpConsult = 'performHearingLossAudiologistFollowUpConsult',
    performLumbarRadiculopathyAssessment = 'performLumbarRadiculopathyAssessment',
    performLumbarRadiculopathyExamination = 'performLumbarRadiculopathyExamination',
    performMdoInterimReportStep = 'performMdoInterimReportStep',
    performMdoReportStep = 'performMdoReportStep',
    performMedConsultAssessment = 'performMedConsultAssessment',
    performProcedure = 'performProcedure',
    performQualityControl = 'performQualityControl',
    performResumeMdoInterimStep = 'performResumeMdoInterimStep',
    performResumeMdoStep = 'performResumeMdoStep',
    performSecondRoundAnswer = 'performSecondRoundAnswer',
    performSurgeryDate = 'performSurgeryDate',
    psychologistReport = 'psychologistReport',
    secretarialAssistentMedScreeningReport = 'secretarialAssistentMedScreeningReport',
    treatmentReport = 'treatmentReport',
    uploadHolterDiary = 'uploadHolterDiary',
}
